import { type JsonDataItem } from 'types';

import { baseQuery } from '../baseQuery';

type PostSubscriptionParams = {
  customerId: string | number;
  service_type_id: number;
  plan_ID: number;
  start_date: string; // YYYY-MM-DD
  email_invoice: 0 | 1;
  comments?: string;
};

type PostSubscriptionResponse = {
  data: JsonDataItem;
  tc_sent: boolean;
  invoice_created: boolean;
};

export const postSubscription = async ({ customerId, ...body }: PostSubscriptionParams) => {
  const response: PostSubscriptionResponse = await baseQuery(`customers/${customerId}/subscriptions`, {
    type: 'POST',
    body,
  });

  return response;
};
